import { Swiper, Autoplay } from "swiper/bundle";
import hoverintent from 'hoverintent';
export default class SwiperClients {
    constructor() {
        console.log('%c👍🏼 Swiper Clients', 'color: yellow');
        
        this.clientsSwipers = document.querySelectorAll(
            '.swiper--clients'
        ) 
    }
    init() {

        let maxSlides = 3;
        this.clientsSwipers.forEach((elem, i) => {
            
            maxSlides = elem.dataset.slides;

            let swiper = new Swiper(elem, {
                loop: true,
                freeMode: false,
                spaceBetween: 15,
                grabCursor: false,
                slidesPerView: 2,
               // slidesPerGroup: 3,
               // loop: true,
                allowTouchMove: false,
                speed: 10000,
                freeModeMomentum: false,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: true
                },
                breakpoints:{
                    500: {
                        slidesPerView: maxSlides,
                    },
                }
                // breakpoints: {
                //     400: {
                //         slidesPerView: 3,
                //     },
                //     600: {
                //         slidesPerView: 4,
                //     },
                //     800: {
                //         slidesPerView: 5,
                //     },
                //     1000: {
                //         slidesPerView: 6,
                //     },
                //     1200: {
                //         slidesPerView: 7,
                //     },
                // }
            });  
            
            let wrapper = elem.querySelector('.swiper-wrapper');
            let transformValue;

            hoverintent(wrapper,
                function() {
                    swiper.autoplay.stop();
                    transformValue = wrapper.style.transform;
                    wrapper.style.transitionDuration = "0ms";
                    wrapper.style.transform = "translate3d(" + swiper.getTranslate() + "px, 0px, 0px)";
                }, function() {
                    wrapper.style.transitionDuration = swiper.params.speed + "ms";
                    wrapper.style.transform = transformValue;
                    swiper.autoplay.start();
                });
              
        })
    } 
}